import React from 'react';
import { Alert, Container } from 'react-bootstrap';

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    componentDidCatch(error, errorInfo) {
        // Catch errors in any components below and re-render with error message
        this.setState({
            error: error,
            errorInfo: errorInfo,
        });
        // You can also log error messages to an error reporting service here
    }

    render() {
        if (this.state.errorInfo) {
            // Error path
            return (
                <Container>
                    <Alert variant={'danger'}>
                        <h1>Что-то пошло не так!</h1>
                        <p>
                            Просьба передать разработчикам системы следующую информацию для выяснения причин проблемы.
                            После чего можете попробовать перезагрузить страницу или (если не поможет) попробовать
                            открыть систему заявок в другом браузере / с другого устройства.
                        </p>
                        <p style={{ whiteSpace: 'pre-wrap' }}>
                            {this.state.error && this.state.error.toString()}
                            <br />
                            {this.state.errorInfo.componentStack}
                        </p>
                    </Alert>
                </Container>
            );
        }
        // Normally, just render children
        return this.props.children;
    }
}
